import axios from 'axios';
import { axiosAiq } from 'config';
import { FENIX_YMS_EXPORTS_PATH, buildFenixYmsHistoryPath } from 'utils/fenixYms';

export const getTransactionExportInfo = async (transactionId) => {
    const response = await axiosAiq.get(`/transactions/trucks/export/info/${transactionId}`);
    return response.data;
};

// The video wall's background check. It bypasses the axiosAiq interceptors: a 401/403 there logs the agent out, and a
// failed check only means the wall asks again later. The timeout keeps a request that never settles from leaving
// the lane without a timer.
export const getTruckTransactionStatus = async (transactionId) => {
    const response = await axios.get(`/transactions/trucks/${transactionId}`, {
        baseURL: axiosAiq.defaults.baseURL,
        withCredentials: true,
        timeout: 30000,
    });
    return response.data?.status;
};

export const exportToYms = async (payload) => {
    const response = await axiosAiq.post(FENIX_YMS_EXPORTS_PATH, payload);
    return response.data;
};

export const getFenixYmsHistory = async (transactionId) => {
    const response = await axiosAiq.get(buildFenixYmsHistoryPath(transactionId));
    return response.data;
};
